/**
 * Session cache for the unassigned sidebar list (UnAssignedRooms remounts on tab switch).
 * Cleared when the user explicitly refreshes the chat list (LiveChat / ChatBar).
 */
const emptyCache = () => ({
  businessId: null,
  /** null = never loaded; [] = loaded empty */
  data: null,
  hasFetched: false,
  /** Server total for tab badge (may exceed loaded page). */
  total: null,
});

let cache = emptyCache();

export function getUnassignedChatListWarmCache() {
  return cache;
}

export function setUnassignedChatListWarmCache(next) {
  cache = { ...emptyCache(), ...next };
}

export function clearUnassignedChatListWarmCache() {
  cache = emptyCache();
}

/**
 * Drop a room from the unassigned warm list and decrement the badge total.
 * Safe when the room is only in `total` (not yet on the loaded page).
 * @returns {{ total: number|null, removed: boolean, row: object|null }}
 */
export function removeRoomFromUnassignedWarmCache(roomId) {
  const id = roomId == null ? "" : String(roomId);
  if (!id) return { total: null, removed: false, row: null };

  const wc = getUnassignedChatListWarmCache();
  const matchesRoom = (room) => String(room?.id) === id;
  const row = Array.isArray(wc.data)
    ? wc.data.find(matchesRoom) || null
    : null;
  const hadTotal = typeof wc.total === "number";

  if (!row && !hadTotal && !Array.isArray(wc.data)) {
    return { total: null, removed: false, row: null };
  }

  const nextData = Array.isArray(wc.data)
    ? wc.data.filter((room) => !matchesRoom(room))
    : wc.data;
  const nextTotal = hadTotal
    ? Math.max(0, wc.total - 1)
    : Array.isArray(nextData)
      ? nextData.length
      : null;

  setUnassignedChatListWarmCache({
    ...wc,
    data: nextData,
    total: nextTotal,
  });

  return { total: nextTotal, removed: true, row };
}
